<template>
    <div style="background: #FAFAFA;">
        <div class="container" style="padding-bottom: 40px; padding-top: 0.5rem;">
            <div class="top-spot mt-5">
                <h5><span><i class="fa fa-chevron-left"></i></span> Account</h5>
                <span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 13.9979C21.9711 17.4119 21.7815 19.294 20.5404 20.5352C19.0755 22 16.7179 22 12.0026 22C7.28733 22 4.9297 22 3.46485 20.5352C2 19.0703 2 16.7127 2 11.9974C2 7.28212 2 4.92448 3.46485 3.45963C4.70599 2.21848 6.58807 2.02895 10.0021 2" stroke="#1C2B3A" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M22 7H14C12.1824 7 11.0867 7.89202 10.6804 8.30029C10.5546 8.42673 10.4917 8.48996 10.4908 8.49082C10.49 8.49168 10.4267 8.55459 10.3003 8.68042C9.89202 9.08671 9 10.1824 9 12V15M22 7L17 2M22 7L17 12" stroke="#1C2B3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
            </div>

            <div class="profile-image-holder">
                <div class="profile-image avatar-dropdown-container" ref="avatarContainer">
                    
                    
                    <div class="avatar-frame" :class="{ 'loading-border': uploading }">
                        <img @click="triggerFileInput" v-if="activeKid && activeKid.avatar_url" :src="activeKid.avatar_url" alt="profile">
                        <img @click="triggerFileInput" v-else src="../../assets/icons/profile-icon.svg" alt="profile">
                        <input 
                            type="file" 
                            ref="fileInput" 
                            accept="image/*" 
                            style="display: none;" 
                            :disabled="uploading"
                            @change="onFileSelected" 
                        />
                    </div>
                    
                    <!-- <span>
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.6973 1.52246C17.1537 0.826396 18.8463 0.826398 20.3027 1.52246C20.9616 1.83736 21.5682 2.36432 22.501 3.15918C22.9074 3.50558 23.0521 3.6276 23.2012 3.72754C23.5682 3.9735 23.9806 4.14388 24.4141 4.22949C24.5901 4.26426 24.7788 4.28073 25.3115 4.32324C26.5331 4.42074 27.3349 4.47654 28.0234 4.71973C29.5454 5.25736 30.7426 6.45462 31.2803 7.97656V7.97754C31.5231 8.66581 31.5792 9.46702 31.6768 10.6885C31.7191 11.2207 31.7357 11.4097 31.7705 11.5859C31.8561 12.0193 32.0265 12.4318 32.2725 12.7988H32.2734C32.3731 12.9476 32.4943 13.0923 32.8408 13.499C33.6358 14.4318 34.1626 15.0384 34.4775 15.6973C35.1736 17.1537 35.1736 18.8463 34.4775 20.3027C34.1626 20.9616 33.6358 21.5682 32.8408 22.501C32.4942 22.9077 32.3722 23.0523 32.2725 23.2012C32.0265 23.5682 31.8561 23.9806 31.7705 24.4141C31.7357 24.5903 31.7191 24.7794 31.6768 25.3115C31.5792 26.533 31.5231 27.3342 31.2803 28.0225V28.0234C30.7426 29.5454 29.5454 30.7426 28.0234 31.2803H28.0225C27.3342 31.5231 26.533 31.5792 25.3115 31.6768C24.7794 31.7191 24.5903 31.7357 24.4141 31.7705C23.9806 31.8561 23.5682 32.0265 23.2012 32.2725C23.0523 32.3722 22.9077 32.4942 22.501 32.8408C21.5682 33.6358 20.9616 34.1626 20.3027 34.4775C18.8463 35.1736 17.1537 35.1736 15.6973 34.4775C15.0384 34.1626 14.4318 33.6358 13.499 32.8408C13.0923 32.4943 12.9476 32.3731 12.7988 32.2734V32.2725C12.4318 32.0265 12.0193 31.8561 11.5859 31.7705C11.4097 31.7357 11.2207 31.7191 10.6885 31.6768C9.46702 31.5792 8.66581 31.5231 7.97754 31.2803H7.97656C6.45462 30.7426 5.25736 29.5454 4.71973 28.0234C4.47654 27.3349 4.42074 26.5331 4.32324 25.3115C4.28073 24.7788 4.26426 24.5901 4.22949 24.4141C4.14388 23.9806 3.9735 23.5682 3.72754 23.2012C3.6276 23.0521 3.50562 22.9075 3.15918 22.501C2.36432 21.5682 1.83736 20.9616 1.52246 20.3027C0.826398 18.8463 0.826396 17.1537 1.52246 15.6973C1.83735 15.0384 2.36433 14.4318 3.15918 13.499C3.50577 13.0923 3.62764 12.9479 3.72754 12.7988C3.97351 12.4318 4.14388 12.0194 4.22949 11.5859C4.26426 11.4099 4.28073 11.2212 4.32324 10.6885C4.42074 9.46689 4.47653 8.66506 4.71973 7.97656C5.25737 6.45463 6.45463 5.25737 7.97656 4.71973C8.66506 4.47653 9.46689 4.42074 10.6885 4.32324C11.2212 4.28073 11.4099 4.26426 11.5859 4.22949C12.0194 4.14388 12.4318 3.97351 12.7988 3.72754C12.9479 3.62764 13.0923 3.50576 13.499 3.15918C14.4318 2.36433 15.0384 1.83735 15.6973 1.52246ZM24.29 13.4463C24.1721 13.3287 23.9811 13.3286 23.8633 13.4463L15.3955 21.9141L12.1367 18.6553C12.0187 18.5374 11.827 18.5373 11.709 18.6553C11.5913 18.7732 11.5919 18.9649 11.71 19.083L15.1816 22.5547C15.2996 22.6726 15.4912 22.6728 15.6094 22.5547L24.29 13.874C24.4081 13.756 24.4081 13.5643 24.29 13.4463Z" fill="#2EBFCA" stroke="#FAFAFA" stroke-width="2"/>
                        </svg>
                    </span> -->
                    <div>
                        <div class="active-avatar-trigger" @click="toggleDropdown">
                            <!-- <img :src="activeAvatarUrl" class="current-img" alt="Profile" /> -->
                            <h6>Select an Avatar</h6>
                            <span class="arrow-indicator" :class="{ 'rotated': isOpen }">▼</span>
                        </div>
                        <transition name="drip-slide">
                            <div v-if="isOpen" class="drip-menu">
                                <div class="drip-header">Choose an Avatar</div>
                                
                                <div class="avatar-list row">
                                    <div 
                                        v-for="avatar in avatarUrl2" 
                                        :key="avatar.id" 
                                        class="avatar-item col-6"
                                        :class="{ 'active-item': avatar.url === activeAvatarUrl }"
                                        @click="selectAvatar(avatar);toggleDropdown "
                                    >
                                        <img :src="avatar.url" :alt="avatar.name" class="list-img" />
                                        <!-- <span class="avatar-name">{{ avatar.name }}</span> -->
                                        <!-- <span v-if="avatar.url === activeAvatarUrl" class="check-mark">✓</span> -->
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <p v-if="activeKid">{{activeKid.firstname}} {{activeKid.lastname}} <small class="relationship">({{ activeKid.relationship }})</small></p>
                    
                </div>
            </div>

            <div class="mt-5 d-none">
                <div class="row">
                    <div class="col-md-6">
                        <div class="current-leaderboard">
                            <h6>Current Vote</h6>
                            <h3>1,3020</h3>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="current-leaderboard">
                            <h6>Leaderboard Rank</h6>
                            <h3>1,3020</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="account-section-holder">
                <div class="account-section" data-toggle="modal" data-target="#switchAccount">
                    <div>
                        <span>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#FAFAFA"/>
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#F5F7FA"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M26 16C26 21.5228 21.5228 26 16 26C10.4771 26 6 21.5228 6 16C6 10.4771 10.4771 6 16 6C21.5228 6 26 10.4771 26 16ZM9.46056 15.0833C9.83331 11.7999 12.624 9.25 16.0096 9.25C18.148 9.25 20.0489 10.2679 21.2521 11.8425C21.5036 12.1716 21.4406 12.6423 21.1115 12.8938C20.7824 13.1453 20.3117 13.0823 20.0602 12.7532C19.1289 11.5344 17.6613 10.75 16.0096 10.75C13.4521 10.75 11.3364 12.6322 10.9733 15.0833H11.3365C11.64 15.0833 11.9135 15.2662 12.0295 15.5466C12.1456 15.8269 12.0812 16.1496 11.8665 16.364L10.6982 17.5307C10.4054 17.8231 9.9311 17.8231 9.63829 17.5307L8.47003 16.364C8.25532 16.1496 8.19097 15.8269 8.30699 15.5466C8.42302 15.2662 8.69656 15.0833 9 15.0833H9.46056ZM22.3617 14.4693C22.0689 14.1769 21.5946 14.1769 21.3018 14.4693L20.1335 15.636C19.9188 15.8504 19.8545 16.1731 19.9705 16.4534C20.0865 16.7338 20.3601 16.9167 20.6635 16.9167H21.0267C20.6636 19.3678 18.5479 21.25 15.9905 21.25C14.3464 21.25 12.8848 20.4729 11.9529 19.2638C11.7 18.9358 11.2291 18.8748 10.901 19.1277C10.5729 19.3806 10.512 19.8515 10.7649 20.1796C11.9689 21.7416 13.8621 22.75 15.9905 22.75C19.376 22.75 22.1667 20.2001 22.5395 16.9167H23C23.3035 16.9167 23.577 16.7338 23.693 16.4534C23.8091 16.1731 23.7447 15.8504 23.53 15.636L22.3617 14.4693Z" fill="#5D6F7C"/>
                            </svg>
                        </span>
                        <small>Switch Account</small>
                    </div>
                    <i class="fa fa-chevron-right"></i>
                </div>
                <div class="account-section" data-toggle="modal" data-target="#addCoach">
                    <div>
                        <span>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#FAFAFA"/>
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#F5F7FA"/>
                                <path d="M16 14C18.2091 14 20 12.2091 20 10C20 7.79086 18.2091 6 16 6C13.7909 6 12 7.79086 12 10C12 12.2091 13.7909 14 16 14Z" fill="#5D6F7C"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 26C18.8501 26 18.0251 26 17.5126 25.4874C17 24.9749 17 24.1499 17 22.5C17 20.8501 17 20.0251 17.5126 19.5126C18.0251 19 18.8501 19 20.5 19C22.1499 19 22.9749 19 23.4874 19.5126C24 20.0251 24 20.8501 24 22.5C24 24.1499 24 24.9749 23.4874 25.4874C22.9749 26 22.1499 26 20.5 26ZM21.0833 20.9444C21.0833 20.6223 20.8222 20.3611 20.5 20.3611C20.1778 20.3611 19.9167 20.6223 19.9167 20.9444V21.9167H18.9444C18.6223 21.9167 18.3611 22.1778 18.3611 22.5C18.3611 22.8222 18.6223 23.0833 18.9444 23.0833H19.9167V24.0556C19.9167 24.3777 20.1778 24.6389 20.5 24.6389C20.8222 24.6389 21.0833 24.3777 21.0833 24.0556V23.0833H22.0556C22.3777 23.0833 22.6389 22.8222 22.6389 22.5C22.6389 22.1778 22.3777 21.9167 22.0556 21.9167H21.0833V20.9444Z" fill="#5D6F7C"/>
                                <path d="M19.4147 17.5074C18.4046 17.1842 17.24 17 16 17C12.134 17 9 18.7909 9 21C9 23.1406 11.9424 24.8884 15.6421 24.9949C15.615 24.8686 15.594 24.7432 15.5775 24.6201C15.4998 24.0424 15.4999 23.3365 15.5 22.586V22.414C15.4999 21.6635 15.4998 20.9576 15.5775 20.3799C15.6639 19.737 15.8705 19.0333 16.4519 18.4519C17.0334 17.8705 17.737 17.6639 18.3799 17.5774C18.6919 17.5355 19.0412 17.5162 19.4147 17.5074Z" fill="#5D6F7C"/>
                            </svg>

                        </span>
                        <small>Add Coach</small>
                    </div>
                    <i class="fa fa-chevron-right"></i>
                </div>
                <div class="account-section" data-toggle="modal" data-target="#kidDetails">
                    <div>
                        <span>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#FAFAFA"/>
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#F5F7FA"/>
                                <path d="M16 14C18.2091 14 20 12.2091 20 10C20 7.79086 18.2091 6 16 6C13.7909 6 12 7.79086 12 10C12 12.2091 13.7909 14 16 14Z" fill="#5D6F7C"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 26C18.8501 26 18.0251 26 17.5126 25.4874C17 24.9749 17 24.1499 17 22.5C17 20.8501 17 20.0251 17.5126 19.5126C18.0251 19 18.8501 19 20.5 19C22.1499 19 22.9749 19 23.4874 19.5126C24 20.0251 24 20.8501 24 22.5C24 24.1499 24 24.9749 23.4874 25.4874C22.9749 26 22.1499 26 20.5 26ZM21.0833 20.9444C21.0833 20.6223 20.8222 20.3611 20.5 20.3611C20.1778 20.3611 19.9167 20.6223 19.9167 20.9444V21.9167H18.9444C18.6223 21.9167 18.3611 22.1778 18.3611 22.5C18.3611 22.8222 18.6223 23.0833 18.9444 23.0833H19.9167V24.0556C19.9167 24.3777 20.1778 24.6389 20.5 24.6389C20.8222 24.6389 21.0833 24.3777 21.0833 24.0556V23.0833H22.0556C22.3777 23.0833 22.6389 22.8222 22.6389 22.5C22.6389 22.1778 22.3777 21.9167 22.0556 21.9167H21.0833V20.9444Z" fill="#5D6F7C"/>
                                <path d="M19.4147 17.5074C18.4046 17.1842 17.24 17 16 17C12.134 17 9 18.7909 9 21C9 23.1406 11.9424 24.8884 15.6421 24.9949C15.615 24.8686 15.594 24.7432 15.5775 24.6201C15.4998 24.0424 15.4999 23.3365 15.5 22.586V22.414C15.4999 21.6635 15.4998 20.9576 15.5775 20.3799C15.6639 19.737 15.8705 19.0333 16.4519 18.4519C17.0334 17.8705 17.737 17.6639 18.3799 17.5774C18.6919 17.5355 19.0412 17.5162 19.4147 17.5074Z" fill="#5D6F7C"/>
                            </svg>

                        </span>
                        <small>My Details</small>
                    </div>
                    <i class="fa fa-chevron-right"></i>
                </div>
                <div class="account-section">
                    <div>
                        <span>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#FAFAFA"/>
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#F5F7FA"/>
                                <path d="M15.2498 6C11.0314 6.00411 8.84888 6.07958 7.46423 7.46423C6.07958 8.84888 6.00411 11.0314 6 15.2498H10.9135C10.5626 14.8114 10.3003 14.2943 10.1573 13.7223C9.61906 11.5693 11.5693 9.61906 13.7223 10.1573C14.2943 10.3003 14.8114 10.5626 15.2498 10.9135V6Z" fill="#5D6F7C"/>
                                <path d="M6 16.75C6.00411 20.9683 6.07958 23.1508 7.46423 24.5355C8.84888 25.9201 11.0314 25.9956 15.2498 25.9997V18.1236C14.4701 19.6809 12.8598 20.75 10.9998 20.75C10.5856 20.75 10.2498 20.4142 10.2498 20C10.2498 19.5858 10.5856 19.25 10.9998 19.25C12.5366 19.25 13.8242 18.1833 14.1628 16.75H6Z" fill="#5D6F7C"/>
                                <path d="M16.75 25.9997C20.9683 25.9956 23.1508 25.9201 24.5355 24.5355C25.9201 23.1508 25.9956 20.9683 25.9997 16.75H17.8369C18.1755 18.1833 19.4632 19.25 21 19.25C21.4142 19.25 21.75 19.5858 21.75 20C21.75 20.4142 21.4142 20.75 21 20.75C19.1399 20.75 17.5296 19.6809 16.75 18.1236V25.9997Z" fill="#5D6F7C"/>
                                <path d="M25.9997 15.2498C25.9956 11.0314 25.9201 8.84888 24.5355 7.46423C23.1508 6.07958 20.9683 6.00411 16.75 6V10.9135C17.1884 10.5626 17.7055 10.3003 18.2774 10.1573C20.4305 9.61906 22.3807 11.5693 21.8424 13.7223C21.6994 14.2943 21.4372 14.8114 21.0862 15.2498H25.9997Z" fill="#5D6F7C"/>
                                <path d="M13.3586 11.6127C14.4701 11.8905 15.2499 12.8892 15.2499 14.0349V15.2499H14.0349C12.8892 15.2499 11.8905 14.4701 11.6127 13.3586C11.349 12.3042 12.3042 11.349 13.3586 11.6127Z" fill="#5D6F7C"/>
                                <path d="M16.75 14.0349V15.2499H17.9649C19.1106 15.2499 20.1093 14.4701 20.3872 13.3586C20.6508 12.3042 19.6957 11.349 18.6413 11.6127C17.5297 11.8905 16.75 12.8892 16.75 14.0349Z" fill="#5D6F7C"/>
                            </svg>
                        </span>
                        <small>Rewards</small>
                    </div>
                    <i class="fa fa-chevron-right"></i>
                </div>
                <div class="account-section" data-toggle="modal" data-target="#verification">
                    <div>
                        <span>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#FAFAFA"/>
                                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#F5F7FA"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5924 7.20027C13.3489 7.4078 13.2271 7.51158 13.0971 7.59874C12.799 7.79854 12.4642 7.93721 12.1121 8.00672C11.9585 8.03705 11.799 8.04977 11.4801 8.07522C10.6787 8.13918 10.278 8.17115 9.94371 8.28923C9.17051 8.56233 8.56233 9.17051 8.28923 9.94371C8.17115 10.278 8.13918 10.6787 8.07522 11.4801C8.04977 11.799 8.03705 11.9585 8.00672 12.1121C7.93721 12.4642 7.79854 12.799 7.59874 13.0971C7.51158 13.2271 7.40781 13.3489 7.20027 13.5924C6.67883 14.2043 6.4181 14.5102 6.26522 14.8301C5.91159 15.57 5.91159 16.43 6.26522 17.1699C6.41811 17.4898 6.67883 17.7957 7.20027 18.4076C7.40778 18.6511 7.51158 18.7729 7.59874 18.9029C7.79854 19.201 7.93721 19.5358 8.00672 19.8879C8.03705 20.0415 8.04977 20.201 8.07522 20.5199C8.13918 21.3213 8.17115 21.722 8.28923 22.0563C8.56233 22.8295 9.17051 23.4377 9.94371 23.7108C10.278 23.8288 10.6787 23.8608 11.4801 23.9248C11.799 23.9502 11.9585 23.963 12.1121 23.9933C12.4642 24.0628 12.799 24.2015 13.0971 24.4013C13.2271 24.4884 13.3489 24.5922 13.5924 24.7997C14.2043 25.3212 14.5102 25.5819 14.8301 25.7348C15.57 26.0884 16.43 26.0884 17.1699 25.7348C17.4898 25.5819 17.7957 25.3212 18.4076 24.7997C18.6511 24.5922 18.7729 24.4884 18.9029 24.4013C19.201 24.2015 19.5358 24.0628 19.8879 23.9933C20.0415 23.963 20.201 23.9502 20.5199 23.9248C21.3213 23.8608 21.722 23.8288 22.0563 23.7108C22.8295 23.4377 23.4377 22.8295 23.7108 22.0563C23.8288 21.722 23.8608 21.3213 23.9248 20.5199C23.9502 20.201 23.963 20.0415 23.9933 19.8879C24.0628 19.5358 24.2015 19.201 24.4013 18.9029C24.4884 18.7729 24.5922 18.6511 24.7997 18.4076C25.3212 17.7957 25.5819 17.4898 25.7348 17.1699C26.0884 16.43 26.0884 15.57 25.7348 14.8301C25.5819 14.5102 25.3212 14.2043 24.7997 13.5924C24.5922 13.3489 24.4884 13.2271 24.4013 13.0971C24.2015 12.799 24.0628 12.4642 23.9933 12.1121C23.963 11.9585 23.9502 11.799 23.9248 11.4801C23.8608 10.6787 23.8288 10.278 23.7108 9.94371C23.4377 9.17051 22.8295 8.56233 22.0563 8.28923C21.722 8.17115 21.3213 8.13918 20.5199 8.07522C20.201 8.04977 20.0415 8.03705 19.8879 8.00672C19.5358 7.93721 19.201 7.79854 18.9029 7.59874C18.7729 7.51158 18.6511 7.40781 18.4076 7.20027C17.7957 6.67883 17.4898 6.41811 17.1699 6.26522C16.43 5.91159 15.57 5.91159 14.8301 6.26522C14.5102 6.4181 14.2043 6.67883 13.5924 7.20027ZM20.3735 13.8631C20.6913 13.5453 20.6913 13.03 20.3735 12.7122C20.0557 12.3943 19.5403 12.3943 19.2225 12.7122L14.3723 17.5624L12.7775 15.9676C12.4596 15.6498 11.9443 15.6498 11.6265 15.9676C11.3087 16.2854 11.3087 16.8007 11.6265 17.1186L13.7968 19.2889C14.1146 19.6067 14.6299 19.6067 14.9478 19.2889L20.3735 13.8631Z" fill="#5D6F7C"/>
                            </svg>
                        </span>
                        <small>Verification</small>
                    </div>
                    <i class="fa fa-chevron-right"></i>
                </div>
            </div>
            <SwitchAccount v-if="allKids" :kidds="allKids"></SwitchAccount>
            <KidDetails></KidDetails>
            <AddCoach></AddCoach>
            <Verification></Verification>
        </div>
    </div>
</template>

<script>
import { fetchSuperkidsParentsKids } from '../../utils';
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import SwitchAccount from "./SwitchAccount";
import AddCoach from "./AddCoach";
import KidDetails from "./KidDetails";
import Verification from "./Verification";
import moment from "moment";
import $ from "jquery";
export default {
    name: "AccountHome",
    components: {
        PageLoader,
        SwitchAccount,
        KidDetails,
        AddCoach,
        Verification,
    },

    data() {
        return {
            allKids: null,
            activeKid: JSON.parse(localStorage.getItem('kidDetails')),
            selectedFile: null,
            avatarUrl: "",
            avatarUrl2: [],
            uploading: false,
            activeAvatarUrl: "",
            isOpen: false,
        };
    },
    created() {
        // Listen for the event from the Modal
        this.$bus.$on('active-kid-updated', () => {
            this.refreshFromStorage();
        });
    },
    beforeDestroy() {
        // Clean up listener when component is destroyed to prevent memory leaks
        window.removeEventListener('click', this.closeDropdownOutside);
    },
    mounted() {
        window.addEventListener('click', this.closeDropdownOutside);
        this.loadKidProfile();
        this.fetchAvatar();
        // this.activeKid = JSON.parse(localStorage.getItem('kidDetails'));
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileSelected(event) {
            const files = event.target.files;
            
            if (!files || files.length === 0) return;

            // Grab the first selected file
            this.selectedFile = files[0];

            // Create a local temporary URL to instantly preview the image on screen
            this.avatarUrl = URL.createObjectURL(this.selectedFile);

            // Automatically upload the file to your API server
            this.uploadToServer();
        },
        async uploadToServer() {
            this.uploading = true;
            const formData = new FormData();
            formData.append('avatar', this.selectedFile);
            formData.append('kid_id', this.activeKid.id);

            try {
               Api.postRequest(`upload-super-kid-avatar`, formData).then(res => {
                // console.log("Reponse", res)
                this.uploading = false;
                if (res.data.success) {
                    // this.loadKidProfile();
                     const storedKid = localStorage.getItem('kidDetails');

                    if (storedKid) {
                        // 2. Parse the string into a mutable JavaScript object
                        const kidObj = JSON.parse(storedKid);
                       

                        // 3. Update the single specific property (e.g., updating the avatar URL)
                        kidObj.avatar_url = res.data.kid.avatar_url; 
                        localStorage.setItem('kidDetails', JSON.stringify(kidObj));
                    }
                    window.location.reload();
                }
               })
            } catch (error) {
                this.uploading = false;
                console.error('Upload failed:', error);
            }
        },
        toggleDropdown(event) {
            event.stopPropagation();
            this.isOpen = !this.isOpen;
        },
        async selectAvatar(chosenAvatar) {
            this.uploading = true;
            const formData = new FormData();
            formData.append('avatar_url', chosenAvatar.url);
            formData.append('kid_id', this.activeKid.id);
            try {
               Api.postRequest(`update-super-kid-avatar`, formData).then(res => {
                // console.log("Reponse", res)
                this.uploading = false;
                if (res.data.success) {
                    // this.loadKidProfile();
                     const storedKid = localStorage.getItem('kidDetails');

                    if (storedKid) {
                        // 2. Parse the string into a mutable JavaScript object
                        const kidObj = JSON.parse(storedKid);
                       

                        // 3. Update the single specific property (e.g., updating the avatar URL)
                        kidObj.avatar_url = res.data.data.avatar_url; 
                        localStorage.setItem('kidDetails', JSON.stringify(kidObj));
                    }
                    window.location.reload();
                }
               })
            } catch (error) {
                this.uploading = false;
                console.error('Upload failed:', error);
            }
        },
        closeDropdownOutside(event) {
            // 1. Grab your component container element from the DOM
            const container = this.$refs.avatarContainer;
            
            // 2. If the dropdown is open and the clicked spot is NOT inside the card, close it!
            if (this.isOpen && container && !container.contains(event.target)) {
                this.isOpen = false;
            }
        },
        async fetchAvatar() {
            try {
                Api.getRequest('fetch-super-kid-avatars').then(res => {
                    // console.log("Avatar:", res);
                    this.avatarUrl2 = res.data.data;
                }).catch(err => {
                    console.log("error:", err);
                });
            } finally {
                // console.log("closed")
            }
        },
        async loadKidProfile() {
            this.loading = true;
            try {
                // 2. Call the imported function directly
                const data = await fetchSuperkidsParentsKids();
                // console.log("Children", data);
                this.allKids = data.data;
                // this.loading = false;
                // console.log("Switch kid", data)
            } catch (error) {
                console.error("Error:", error);
            } finally {
                this.loading = false;
            }
        },
        refreshFromStorage(event) {
            this.activeKid = JSON.parse(localStorage.getItem('kidDetails'));
            console.log("activeKid", this.activeKid)
        }
    }
};
</script>

<style lang="scss" scoped>

.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
}

.profile-image {
    margin-top: 40px;
    position: relative;
    width: fit-content;
    margin: auto;
    img {
        width: 90px;
        height: 90px;
        object-fit: cover;
        border-radius: 24px;
        cursor: pointer;
        background: #e7e7e7;
    }
    p {
        margin-top: 20px;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: #4B4B4F;
        text-align: center;
        margin-bottom: 3px;
    }
    span {
       
    }
    
}
.relationship {
    font-family: Lato;
    font-size: 13px;
    color: #8c8d8e;
}


.current-leaderboard {
    margin: auto;
    border: 1px solid #F5F7FA;
    border-radius: 20px;
    background-color: #ffffff;
    padding: 15px 20px;
    margin-bottom: 15px;
    // margin-top: 25px;
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        color: #5D6F7C;
        line-height: 22px;
        text-align: left;
        margin-bottom: 20px;

    }
    h3 {
        font-family: Poppins;
        font-weight: 600;
        font-size: 26px;
        line-height: 24px;
        color: #1C2B3A;
        text-align: left;
    }

}

.account-section-holder {
    margin-top: 30px;
}

.account-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding: 20px;
    border: 1px solid #F5F7FA;
    background-color: #ffffff;
    border-radius: 12px;
    margin-bottom: 15px;
    cursor: pointer;
    small {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #1C2B3A;
        text-align: left;
        margin-left: 14px;
    }
}

// /* TRIGGERED WHEN UPLOADING: Adds the spinning gradient */
// .loading-border {
//   background: conic-gradient(#3498db 0deg, #e74c3c 180deg, #ddd 360deg);
//   animation: spinClockwise 1.5s linear infinite;
// }

// @keyframes spinClockwise {
//   from {
//     transform: rotate(0deg);
//   }
//   to {
//     transform: rotate(360deg);
//   }
// }






.avatar-dropdown-container {
  position: relative;
  display: inline-block;
  font-family: Lato;
}

/* Main Clickable Trigger Area */
.active-avatar-trigger {
//   width: 140px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background: #f8f9fa;
  padding: 6px 12px;
  border-radius: 30px;
  border: 1px solid #e2e8f0;
  user-select: none;
  h6 {
    font-family: Lato;
    font-size: 14px;
    margin-bottom: 0;
  }
}

.current-img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
}

.arrow-indicator {
  font-size: 10px;
  color: #718096;
  transition: transform 0.2s ease;
    position: absolute !important;
    right: 16px !important;
    top: 119px !important;
}

.arrow-indicator.rotated {
  transform: rotate(180deg);
}

/* The Dropdown Menu (The Drip Panel) */
.drip-menu {
  position: absolute;
  top: 76%;
  left: 0;
  width: 220px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  border: 1px solid #e2e8f0;
  z-index: 100;
  overflow: hidden;
  transform-origin: top center; /* Makes it drip down from the top */
}

.drip-header {
  padding: 10px 14px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #a0aec0;
  background: #f7fafc;
  border-bottom: 1px solid #edf2f7;
}

.avatar-list {
  max-height: 250px;
  overflow-y: auto;
  padding: 0 10px;
}

/* Individual List Item Rows */
.avatar-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.avatar-item:hover {
  background: #f7fafc;
}

.active-item {
  background: #ebf8ff;
}

.list-img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-name {
  font-size: 14px;
  color: #2d3748;
  flex-grow: 1;
}

.check-mark {
  color: #3182ce;
  font-weight: bold;
}

/* Vue 2 "Drip" Animation Core Logic */
.drip-slide-enter-active, .drip-slide-leave-active {
  transition: transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.1), opacity 0.2s ease;
}

.drip-slide-enter, .drip-slide-leave-to {
  transform: scaleY(0);
  opacity: 0;
}


/* 1. Base structure for your image frame wrapper */
.avatar-frame {
  position: relative;
  width: 100px;
  height: 100px; 
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding: 4px; 
  margin: auto;
}

/* 2. THE MULTI-COLORED GRADIENT: Only activates when uploading is true */
.avatar-frame.loading-border::before {
  content: '';
  position: absolute;
  width: 150%; 
  height: 150%;
  background: conic-gradient(
    #3b82f6 0deg, 
    #8b5cf6 90deg, 
    #ec4899 180deg, 
    #f59e0b 270deg, 
    #3b82f6 360deg
  );
  animation: spinBorderClockwise 1.2s linear infinite;
  z-index: 1;
}

/* 3. The Solid Inner Mask: Creates the separation line between image and colors */
.avatar-frame::after {
  content: '';
  position: absolute;
  inset: 4px;
  background: white;
  border-radius: 50%;
  z-index: 2;
}

/* 4. Keeps your actual profile images isolated and locked in place */
.avatar-frame img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #e2e3e3;
  cursor: pointer;
  z-index: 3;
}
/* Rotates ONLY the gradient element background layer */
@keyframes spinBorderClockwise {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


</style>